export default "__VITE_ASSET__ChWBUU5s__"